import React from 'react';

import { divideGrid } from 'Core/Utils/BreakPoints';
import Overlay from 'Core/Components/Overlay';
import LightBox from 'Core/Components/LightBox';

class PhotoWall extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      activePhoto: null
    };

    this.updateActivePhoto = this.updateActivePhoto.bind(this);
    this.clearActivePhoto = this.clearActivePhoto.bind(this);
  }

  updateActivePhoto (activePhoto) {
    this.setState({ activePhoto });
  }

  clearActivePhoto () {
    this.setState({ activePhoto: null });
  }

  render () {
    const { list } = this.props;
    const columnSpan = {
      md: 'md-' + divideGrid(list.length, 0, 3),
      lg: 'lg-' + divideGrid(list.length, 0, 4)
    }
    const className = `photo-wall-item xs-6 ${columnSpan.md} ${columnSpan.lg}`;

    const photoList = list.map(photo => {
      return (
        <Overlay
          key={photo}
          image={photo}
          className={className}
          onClick={() => this.updateActivePhoto(photo)}
        />
      );
    });

    return (
      <row className="PhotoWall justify-center">
        {photoList}
        <LightBox
          photoList={list}
          photo={this.state.activePhoto}
          onClose={this.clearActivePhoto}
          onNavigate={this.updateActivePhoto}
        />
      </row>
    );
  }
};

export default PhotoWall;



// WEBPACK FOOTER //
// ./client/Site/Ui/PhotoWall.jsx